import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Banner } from "app/modules/shared/banner/Banner";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { fetchCompanyLicence, selectCompanyLicence } from "./LicenceBannerSlice";

export function LicenceBanner() {
  const thunkDispatch = useThunkDispatch();

  useEffect(() => {
    thunkDispatch(fetchCompanyLicence());
  }, [thunkDispatch]);

  const companyLicence = useSelector(selectCompanyLicence);
  let licenceBanner;

  if (
    companyLicence &&
    companyLicence.cplUnitLimit &&
    companyLicence.cplUnitCount &&
    (companyLicence.licenceWarning || companyLicence.licenceExceeded)
  ) {
    licenceBanner = (
      <Banner
        data-test-id="licence-banner__dismiss-button"
        title="Your licence needs attention"
        iconClassName="fa-warning"
        variant={companyLicence.licenceExceeded ? "danger" : "warning"}
      >
        Your unit count{" "}
        {companyLicence.licenceExceeded ? "has exceeded your licence limit" : "is approaching your licence limit"}. (
        {companyLicence.cplUnitCount}/{companyLicence.cplUnitLimit})
      </Banner>
    );
  }

  return <>{licenceBanner}</>;
}
